import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/game-assessment/page.tsx")